import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: theme => css`
    position: relative;
    max-width: 420px;
    padding: ${theme.spacing.md} 40px;
    border-radius: ${theme.border.radius.lg};
    background-color: ${theme.colors.background.white};
    box-sizing: border-box;
    font-family: ${theme.typography.label.fontFamily};

    @media screen and (max-width: 768px) {
      max-width: 380px;
    }

    > h2 {
      line-height: 32px;
      color: ${theme.colors.neutral[500]};
      font-family: ${theme.typography.label.fontFamily};
    }

    > p {
      margin: ${theme.spacing.xxs} 0;
      color: ${theme.colors.neutral[400]};
    }

    > ul {
      margin-bottom: ${theme.spacing.sm};

      li {
        display: flex;
        align-items: center;
        color: ${theme.colors.neutral[400]};

        span {
          display: inline-flex;
          margin-left: 4px;
        }
      }
    }
  `,

  inputWrapper: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,

  buttonWrapper: ({ spacing }) => css`
    margin: ${spacing.md} 0;
  `,

  linkSupport: ({ colors, spacing }) => css`
    color: ${colors.background.white};
    margin: ${spacing.xs} 0;
    position: relative;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      margin: ${spacing.md};
    }

    &:hover {
      color: ${colors.background.white};
    }
  `,
})

export default useStyles
